<app-dropdown-panel
    [topText]="topText"
    [labels]="dropCfg.labels"
    [classes]="dropCfg.classes"
    [severities]="dropCfg.severities"
    [icons]="dropCfg.icons"
    [tooltips]="dropCfg.tooltips"
    [disabled]="dropCfg.disabled"
    [tooltipLinks]="dropCfg.tooltipLinks"
    [tooltipLinkLabels]="dropCfg.tooltipLinkLabels"
    [tooltipAutoHide]="dropCfg.tooltipAutoHide"
    [functions]="dropCfg.functions"
    [showSpinner]="dropCfg.showSpinner"
    [showDividers]="dropCfg.showDividers"
    [buttonLabel]="dropCfg.buttonLabel"
    [buttonIcon]="dropCfg.buttonIcon"
/>
